<ng-template #ngTemplateCardTitle>
    <div style="display: flex;">

        <button nz-button (click)="togglePanel()" [nzType]="panelActive ? 'default' : 'default'"
            style="margin-right: 10px;border:none!important">
            <i nz-icon [nzType]="panelActive ? 'up' : 'down'"></i>
        </button>


        <h1 class="heading-text">
            <span class="event-title-trigger" nz-tooltip [nzTooltipTitle]="event?.event_name" nzTooltipPlacement="top">
                <img *ngIf="!panelActive && event?.photo" class="shadow" [src]="getBase64Image(event?.photo)"
                    alt="Event Img" style="width: auto; height: 30px;
                                                            border-radius: 8px;" />
                <nz-icon *ngIf="event?.photo == null || event?.photo == ''" nzType="calendar" nzTheme="outline" />
                <span style="display:inline-flex; flex-direction:column; vertical-align:middle;">
                    <strong style="font-size:14px;">
                        {{ (event?.event_name?.length || 0) > 40 ? ((event?.event_name | slice:0:40) + '...') :
                        (event?.event_name || '') }}
                    </strong>
                    <span style="font-size:11px; color:#999; font-weight:normal; line-height:1.2;">{{ event?.loa_number }}</span>
                </span>
            </span>

        </h1>

        <!-- <span style="font-size: 10px; color: grey; margin-top: 8px; margin-left: 10px;"> ({{ event?.project_details?.name ? event?.project_details?.name : 'No Project' }})</span> -->
    </div>
</ng-template>

<ng-template #nzExtra>


    <div style="display: flex;" (click)="$event.stopPropagation()">

        <div style="padding-top: 5px;">

            <nz-tag [nzColor]="'blue'" [nzBordered]="false" nz-tooltip nzTooltipTitle="Attendees">
                <strong><nz-icon nzType="usergroup-delete" nzTheme="outline" /> {{ event?.number_of_attendees
                    }}</strong>
            </nz-tag>

            <nz-tag *ngIf=" eventDate > currentDate && eventMonth >= currentMonth" [nzColor]="'magenta'"
                [nzBordered]="false">
                <strong><nz-icon nzType="clock-circle" nzTheme="outline" /> Event is going to start in
                    {{getStartDays(event?.event_datetime)}} days.</strong>

            </nz-tag>
            <nz-tag [nzColor]="'red'" [nzBordered]="false" *ngIf="eventMonth < currentMonth || currentDate > eventDate">

                <strong><nz-icon nzType="clock-circle" nzTheme="outline" /> The event date has already passed.</strong>
            </nz-tag>

            <nz-tag [nzColor]="'green'" [nzBordered]="false" *ngIf="event?.status_name == 'Completed'" nz-tooltip
                nzTooltipTitle="Status">
                <strong><nz-icon nzType="flag" nzTheme="outline" /> Finished</strong>
            </nz-tag>

            <nz-tag [nzColor]="'red'" [nzBordered]="false" *ngIf="event?.status_name == 'Cancelled'" nz-tooltip
                nzTooltipTitle="Status">
                <strong><nz-icon nzType="flag" nzTheme="outline" /> Cancelled</strong>
            </nz-tag>
            <nz-tag [nzColor]="'blue'" [nzBordered]="false" *ngIf="event?.status_name == 'Upcoming'" nz-tooltip
                nzTooltipTitle="Status">
                <strong><nz-icon nzType="flag" nzTheme="outline" /> Upcoming</strong>
            </nz-tag>
            <nz-tag [nzColor]="'yellow'" [nzBordered]="false" *ngIf="event?.status_name == 'In Progress'" nz-tooltip
                nzTooltipTitle="Status">
                <strong><nz-icon nzType="flag" nzTheme="outline" /> In Progress</strong>
            </nz-tag>

            <!-- <nz-tag [nzColor]="'lime'" [nzBordered]="false" *ngIf="event?.duration_name" nz-tooltip
                nzTooltipTitle="Event Duration">
                <strong><nz-icon nzType="carry-out" nzTheme="outline" /> {{event?.duration_name}}</strong>
            </nz-tag> -->

        </div>




        <!-- <button nz-button nzType="primary" style="margin-left:20px;float:inline-end">
                <nz-icon nzType="edit" nzTheme="fill" />
            </button> -->


        <button nz-button nzType="default" style="margin-left:10px;float:inline-end" (click)="editEvent(event)">
            <nz-icon nzType="edit" nzTheme="fill" />
        </button>
        <button nz-button nzDanger style="margin-left:10px;float:inline-end" class="custom-popconfirm" nz-popconfirm
            [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'" [nzPopconfirmTitle]="popconfirmTpl"
            nzPopconfirmPlacement="bottom" (nzOnConfirm)="deleteEvent(event)">
            <nz-icon nzType="delete" nzTheme="fill" />
        </button>

    </div>


</ng-template>


<div [ngClass]="isConsolePage ? 'console' : 'standalone'" style="padding: 2px;">
    <nz-collapse class="event-collapse shadow">
        <nz-collapse-panel [nzHeader]="ngTemplateCardTitle" [(nzActive)]="panelActive" [nzExtra]="nzExtra"
            [nzShowArrow]="false" [nzDisabled]="false">
            <div nz-row [nzGutter]="16">
                <div nz-col [nzSpan]="8">
                    <div class="event-image-card">
                        <div class="event-image-wrap" *ngIf="event?.photo; else noEventPhoto">
                            <img [src]="getBase64Image(event?.photo)" alt="Event" class="event-cover-image" />
                        </div>
                        <ng-template #noEventPhoto>
                            <div class="event-image-wrap">
                                <nz-skeleton-element class="default-event-Image" nzType="image" [nzActive]="false"></nz-skeleton-element>
                            </div>
                        </ng-template>
                    </div>
                </div>

                <div nz-col [nzSpan]="16">


                    <div class="event-details-grid card-soft card-summary">
                        <div class="detail-group summary-grid summary-grid-3">
                            <div class="detail-item">
                                <div class="icon-value-pair">
                                    <div class="icon-wrapper" data-tooltip="Format">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="icon">
                                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                            <polyline points="14 2 14 8 20 8"></polyline>
                                            <line x1="16" y1="13" x2="8" y2="13"></line>
                                            <line x1="16" y1="17" x2="8" y2="17"></line>
                                            <polyline points="10 9 9 9 8 9"></polyline>
                                        </svg>
                                    </div>
                                    <div class="value">{{ event?.event_format_name ? event?.event_format_name : 'NA' }}
                                    </div>
                                </div>
                            </div>
                            <div class="detail-item">
                                <div class="icon-value-pair">
                                    <div class="icon-wrapper" data-tooltip="Type">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="icon">
                                            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                                            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z">
                                            </path>
                                        </svg>
                                    </div>
                                    <!-- <div class="value">{{ event?.event_type_name }}</div> -->
                                    <div class="value">{{ event?.event_type_details?.name }}</div>

                                </div>
                            </div>
                            <div class="detail-item">
                                <div class="icon-value-pair">
                                    <div class="icon-wrapper" data-tooltip="Budget">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="icon">
                                            <line x1="12" y1="1" x2="12" y2="23"></line>
                                            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                                        </svg>
                                    </div>
                                    <div class="value">
                                        {{ event?.budget_currency_amount | currency :
                                        event?.budget_currency_type_details.symbol
                                        }}
                                        <span style="font-size: 10px; color: rgb(95, 95, 95);">
                                            ({{event?.budget_amount | currency : 'USD'}} -
                                            {{event?.budget_type.replaceAll('_', ' ') | titlecase}})</span>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="detail-group summary-grid summary-grid-3 summary-address-row">
                            <div class="detail-item span-2">
                                <div class="icon-value-pair" >
                                    <div class="icon-wrapper" data-tooltip="Location">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="icon">
                                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                            <circle cx="12" cy="10" r="3"></circle>
                                        </svg>
                                    </div>

                                    <div class="value" *ngIf="event?.city_name || event?.city_state || event?.city_country">
                                        {{ event?.city_name }}, {{ event?.city_state }}, {{ event?.city_country }}
                                    </div>
                                    <div *ngIf="!event?.city_name && !event?.city_state && !event?.city_country" class="value">
                                        NA</div>
                                </div>
                            </div>

                            <div class="detail-item" *ngIf="event?.country_name && event?.country_name.length > 0">
                                <div class="icon-value-pair">
                                    <div class="icon-wrapper" data-tooltip="Location">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="icon">
                                            <circle cx="12" cy="12" r="10"></circle>
                                            <line x1="2" y1="12" x2="22" y2="12"></line>
                                            <path
                                                d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z">
                                            </path>
                                        </svg>
                                    </div>
                                    <div class="value">
                                        <span [nz-tooltip]="event.country_name.length > 1 ? cityTooltip : null"
                                            nzTooltipPlacement="top" style="cursor: pointer;">
                                            {{ event.country_name[0].name }}<span *ngIf="event.country_name.length > 1">
                                                ...</span>
                                        </span>
                                        <ng-template #cityTooltip>
                                            <span *ngFor="let city of event.country_name; let last = last">
                                                {{ city.name }}<span *ngIf="!last">, </span>
                                            </span>
                                        </ng-template>
                                    </div>


                                </div>
                            </div>

                            <div class="detail-item">
                                <div class="icon-value-pair">
                                    <div class="icon-wrapper" data-tooltip="Project">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="icon">
                                            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71">
                                            </path>
                                            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71">
                                            </path>
                                        </svg>
                                    </div>
                                    <div class="value">
                                        <a *ngIf="event?.project_details?.id && event?.project_details?.name"
                                            href="javascript:void(0)" class="link"
                                            [title]="event?.project_details?.name"
                                            (click)="goToProject(event?.project_details.id)">
                                            {{ event?.project_details?.name }}
                                        </a>
                                        <span style="cursor: default;"
                                            *ngIf="!event?.project_details?.id || !event?.project_details?.name">No
                                            Project</span>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="detail-item">
                                <div class="icon-value-pair">
                                    <div class="icon-wrapper" data-tooltip="Client">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1"
                                            stroke-linecap="round" stroke-linejoin="round" class="icon">

                                            <rect x="5.5" y="1" width="5" height="5" rx="1" ry="1"></rect>
                                            <line x="8" y="6" x2="8" y2="9"></line>
                                            <line x="4" y="9" x2="12" y2="9"></line>
                                            <rect x="1" y="11" width="5" height="5" rx="1" ry="1"></rect>
                                            <rect x="10" y="11" width="5" height="5" rx="1" ry="1"></rect>
                                        </svg>
                                    </div>
                                    <div class="value">
                                        <a *ngIf="event?.client?.id && event?.client?.name" href="javascript:void(0)"
                                            class="link" [title]="event?.client.name"
                                            (click)="goToClient(event?.client.id)">
                                            {{ event?.client.name }}
                                        </a>
                                        <span style="cursor: default;"
                                            *ngIf="!event?.client?.id || !event?.client?.name">No Client</span>
                                    </div>
                                </div>
                            </div> -->
                        </div>


                        <div class="detail-group summary-grid summary-grid-2">
                            <div class="detail-item full-width">
                                <div class="icon-value-pair">
                                    <div class="icon-wrapper" data-tooltip="Client Industries Focus">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1"
                                            stroke-linecap="round" stroke-linejoin="round" class="icon">

                                            <rect x="5.5" y="1" width="5" height="5" rx="1" ry="1"></rect>
                                            <line x="8" y="6" x2="8" y2="9"></line>
                                            <line x="4" y="9" x2="12" y2="9"></line>
                                            <rect x="1" y="11" width="5" height="5" rx="1" ry="1"></rect>
                                            <rect x="10" y="11" width="5" height="5" rx="1" ry="1"></rect>
                                        </svg>
                                    </div>
                                    <div class="value">
                                        <a *ngIf="event?.client?.id && event?.client?.name" href="javascript:void(0)"
                                            class="link" [title]="event?.client.name"
                                            (click)="goToClient(event?.client.id)">
                                            {{ event?.client.name }}
                                        </a>
                                        <span style="cursor: default;"
                                            *ngIf="!event?.client?.id || !event?.client?.name">No
                                            Client</span>
                                    </div>
                                </div>
                            </div>

                            <div class="detail-item full-width">
                                <div class="icon-value-pair" *ngIf="event?.industry_details.length > 0">
                                    <div class="icon-wrapper" data-tooltip="Client Industries Focus">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="icon">
                                            <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                                            <path d="M2 17l10 5 10-5"></path>
                                            <path d="M2 12l10 5 10-5"></path>
                                        </svg>
                                    </div>
                                    <div class="value tags" *ngIf="event?.industry_details">
                                        <span class="tag" *ngFor="let industry of event.industry_details">{{
                                            industry.name
                                            }}</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="detail-group">
                            <div class="detail-item">
                                <div class="label-top">BEC Event Manager</div>
                                <div class="value user-info">
                                    <span class="user-avatar">{{ (event?.assigned_to_name &&
                                        event?.assigned_to_name.length > 0 && event?.assigned_to_name[0]?.name) ?
                                        event.assigned_to_name[0].name[0].toUpperCase() : '?' }}</span>
                                    <span class="user-name"
                                        [nz-tooltip]="event?.assigned_to_name && event.assigned_to_name.length > 1 ? assignedToTooltip : null"
                                        nzTooltipPlacement="top" style="cursor: pointer;">
                                        <span *ngIf="event?.assigned_to_name && event.assigned_to_name.length > 0">
                                            {{ event.assigned_to_name[0].name }}<span
                                                *ngIf="event.assigned_to_name.length > 1"> ...</span>
                                        </span>
                                        <span
                                            *ngIf="!event?.assigned_to_name || event?.assigned_to_name.length === 0">&nbsp;-</span>
                                    </span>
                                    <ng-template #assignedToTooltip>
                                        <span *ngFor="let manager of event?.assigned_to_name; let last = last">
                                            {{ manager.name }}<span *ngIf="!last">, </span>
                                        </span>
                                    </ng-template>
                                </div>
                            </div>
                            <div class="detail-item">
                                <div class="label-top">On-Site Event Manager</div>
                                <div class="value user-info">
                                    <span class="user-avatar">{{ (event?.event_manager_name &&
                                        event?.event_manager_name.length > 0 && event?.event_manager_name[0]?.name) ?
                                        event.event_manager_name[0].name[0].toUpperCase() : '?' }}</span>
                                    <span class="user-name"
                                        [nz-tooltip]="event?.event_manager_name && event.event_manager_name.length > 1 ? eventManagerTooltip : null"
                                        nzTooltipPlacement="top" style="cursor: pointer;">
                                        <span *ngIf="event?.event_manager_name && event.event_manager_name.length > 0">
                                            {{ event.event_manager_name[0].name }}<span
                                                *ngIf="event.event_manager_name.length > 1"> ...</span>
                                        </span>
                                        <span
                                            *ngIf="!event?.event_manager_name || event?.event_manager_name.length === 0">&nbsp;-</span>
                                    </span>
                                    <ng-template #eventManagerTooltip>
                                        <span *ngFor="let manager of event?.event_manager_name; let last = last">
                                            {{ manager.name }}<span *ngIf="!last">, </span>
                                        </span>
                                    </ng-template>
                                </div>
                            </div>
                            <!-- <div class="detail-item">
                                <div class="label-top"> &nbsp;</div>
                                <div class="value user-info" (click)="OpenPdfModal()" style="cursor: pointer;">
                                    <span class="user-avatar"> <nz-icon nzType="download" nzTheme="outline" /></span>
                                    <span class="user-name">Download PDF</span>
                                </div>
                            </div> -->


                            <div class="detail-item">
                                 <div class="label-top">Assigned Group</div>
                                <div class="icon-value-pair">
                                    <div class="icon-wrapper" data-tooltip="Assigned Group">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="icon">
                                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                            <circle cx="9" cy="7" r="4"></circle>
                                            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                                            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                        </svg>
                                    </div>
                                    <div class="value">
                                        <div class="tags">
                                            <span class="tag" *ngIf="event?.assigned_group_name">{{
                                                event?.assigned_group_name }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>




                        </div>
                    </div>
                </div>
            </div>

            <div nz-row [nzGutter]="16">
                <div nz-col [nzSpan]="24" style="margin-top:20px;">


                    <div class="event-details-grid card-soft card-schedule">
                        <div class="detail-group compact-actions-row">

                            <div class="detail-item" *ngIf="event?.event_url">
                                <div class="icon-value-pair">
                                    <div class="icon-wrapper" data-tooltip="Event URL">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="icon">
                                            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71">
                                            </path>
                                            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71">
                                            </path>
                                        </svg>
                                    </div>
                                    <div class="value">
                                        <a [href]="event?.event_url" target="_blank" class="link"
                                            [title]="event?.event_url"
                                            style="display:inline-block; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                            {{ (event?.event_url?.length || 0) > 40 ? ('...' + (event?.event_url |
                                            slice:-40)) :
                                            (event?.event_url || '')
                                            }}
                                        </a>
                                    </div>
                                </div>
                            </div>


                            <div class="">
                                <div class="icon-value-pair">
                                    <div class="icon-wrapper" data-tooltip="Timezone">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="icon">
                                            <circle cx="12" cy="12" r="10"></circle>
                                            <line x1="12" y1="2" x2="12" y2="22"></line>
                                            <path
                                                d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z">
                                            </path>
                                        </svg>
                                    </div>
                                    <div class="value">
                                        {{event?.time_zone_details?.name ? event?.time_zone_details?.name : 'NA'}}
                                        <span *ngIf="event?.time_zone_details"
                                            style="font-size: 10px; color: rgb(95, 95, 95);">({{event?.time_zone_details?.offset}})</span>
                                    </div>
                                </div>
                            </div>



                            <div class="">
                                <div class="value user-info pdf-action" (click)="OpenPdfModal()" style="cursor: pointer;">
                                    <span class="user-avatar"> <nz-icon nzType="download" nzTheme="outline" /></span>
                                    <span class="user-name">Download PDF</span>
                                </div>
                            </div>

                        </div>



                        <!-- <div class="detail-group">


                            <div class="detail-item">
                                <div class="icon-value-pair">
                                    <div class="icon-wrapper" data-tooltip="Start Date & Time">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="icon">
                                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                            <line x1="16" y1="2" x2="16" y2="6"></line>
                                            <line x1="8" y1="2" x2="8" y2="6"></line>
                                            <line x1="3" y1="10" x2="21" y2="10"></line>
                                        </svg>
                                    </div>
                                    <div class="value">
                                        {{ event?.start_datetime | date:'medium'}}
                                    </div>
                                </div>
                            </div>

                            <div class="detail-item">
                                <div class="icon-value-pair">
                                    <div class="icon-wrapper" data-tooltip="End Date & Time">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="icon">
                                            <circle cx="12" cy="12" r="10"></circle>
                                            <polyline points="12 6 12 12 16 14"></polyline>
                                        </svg>
                                    </div>
                                    <div class="value">
                                        {{ event?.end_datetime ? (event?.end_datetime | date:'medium') : 'NA'}}
                                    </div>
                                </div>
                            </div>
                        </div> -->





                        <div class="event-days-container">
                            <div class="event-day-row header-row">
                                <div class="day-cell header-cell">Day</div>
                                <div class="date-cell header-cell">Event Date</div>
                                <div class="time-cell header-cell">Start Time</div>
                                <div class="time-cell header-cell">End Time</div>
                                <div class="duration-cell header-cell">Duration</div>
                            </div>

                            <ng-container *ngIf="eventDates && eventDates.length > 0; else noDays">
                                <div class="event-day-row" *ngFor="let day of eventDates; let i = index">
                                    <div class="day-cell data-cell">Day {{ i + 1 }}</div>

                                    <div class="date-cell data-cell">{{ day.event_date | date:'dd-MM-yyyy' }}</div>

                                    <div class="time-cell data-cell">{{ day.start_time | date:'shortTime' }}</div>

                                    <div class="time-cell data-cell">{{ day.end_time | date:'shortTime' }}</div>

                                    <div class="duration-cell data-cell">{{ day.duration ? day.duration : 'Full Day' }}
                                    </div>
                                </div>
                            </ng-container>

                            <ng-template #noDays>
                                <div class="no-days-message">No specific event days defined. Showing overall duration
                                    details in original section.</div>
                                <!-- <div class="detail-group single-day-fallback">
                                    <div class="detail-item">
                                        <div class="icon-value-pair">
                                            <div class="icon-wrapper" data-tooltip="Start Date & Time">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                                    class="icon">
                                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                                    <line x1="16" y1="2" x2="16" y2="6"></line>
                                                    <line x1="8" y1="2" x2="8" y2="6"></line>
                                                    <line x1="3" y1="10" x2="21" y2="10"></line>
                                                </svg>
                                            </div>
                                            <div class="value">
                                                <div class="label-top">Start Date & Time</div>
                                                {{ event?.start_datetime | date:'medium'}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="detail-item">
                                        <div class="icon-value-pair">
                                            <div class="icon-wrapper" data-tooltip="End Date & Time">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                                    class="icon">
                                                    <circle cx="12" cy="12" r="10"></circle>
                                                    <polyline points="12 6 12 12 16 14"></polyline>
                                                </svg>
                                            </div>
                                            <div class="value">
                                                <div class="label-top">End Date & Time</div>
                                                {{ event?.end_datetime ? (event?.end_datetime | date:'medium') : 'NA'}}
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                            </ng-template>
                        </div>



                    </div>

                </div>
            </div>

        </nz-collapse-panel>

    </nz-collapse>
</div>




<div style="margin-top: 10px;"></div>

<nz-row>
    <nz-col [nzSpan]="24" [ngClass]="isConsolePage ? 'console' : 'standalone'">
        <nz-tabset [nzSize]="'small'" nzType="card" [(nzSelectedIndex)]="selectedTabIndex"
            [nzDestroyInactiveTabPane]="true" (nzSelectedIndexChange)="onTabChange($event)">
            <nz-tab [nzTitle]="nzTitleProjects" [nzDisabled]="tab.disabled"
                *ngFor="let tab of tabList; let i = index; trackBy: trackByFn;">
                <ng-template #nzTitleProjects>
                    <i nz-icon [nzType]="tab.icon"></i> {{tab?.name}}
                </ng-template>
                <ng-template nz-tab>
                    <app-cet-dashboard [tabData]="tabData" *ngIf="selectedTabIndex == 0"
                        (selectedIndex)="onRedirect($event)"></app-cet-dashboard>
                    <app-cet-tasks #cetTaskAll *ngIf="selectedTabIndex == 1 " [projectId]="event.project_details"
                        [displayData]="'all'" [eventId]="tabData.id"></app-cet-tasks>

                    <!-- --- new design --- -->
                    <app-cet-sourcing-needs-v2 #cetSourcingNeeds *ngIf="selectedTabIndex == 2" [eventId]="tabData.id"
                        [allEventData]="event"></app-cet-sourcing-needs-v2>

                    <!-- [souringNeedId]="event.sourcing_need" -->

                    <app-cet-compliance-safety #cetComplianceSafety *ngIf="selectedTabIndex == 3" [eventId]="tabData.id"
                        [eventData]="event" [sourcingNeedRecordId]="event.sourcing_need"></app-cet-compliance-safety>


                    <!-- <app-cet-tasks #cetTaskPending *ngIf="selectedTabIndex == 2 " [projectId]="event.project_details" [displayData]="'pending'"></app-cet-tasks> -->
                    <app-cet-outsourcing #cetOutsourcing *ngIf="selectedTabIndex == 4"
                        [eventId]="tabData.id"></app-cet-outsourcing>
                    <app-cet-inquiry #cetInquiry *ngIf="selectedTabIndex == 5" [eventId]="tabData.id"></app-cet-inquiry>
                    <app-cet-vendor-requests #vendorTequests *ngIf="selectedTabIndex == 6"
                        [eventId]="tabData.id"></app-cet-vendor-requests>
                    <app-cet-quotations #cetQuotations *ngIf="selectedTabIndex == 7" [eventId]="tabData.id"
                        [eventData]="eventModel.value"></app-cet-quotations>
                    <app-cet-invoices #cetInvoices *ngIf="selectedTabIndex == 8"
                        [eventId]="tabData.id"></app-cet-invoices>
                    <app-advanced-payments #addvancePayments *ngIf="selectedTabIndex == 9"
                        [eventId]="tabData.id"></app-advanced-payments>
                    <app-cet-notes #cetNotes *ngIf="selectedTabIndex == 10" [eventId]="tabData.id"></app-cet-notes>
                    <!-- <app-cet-notes #cetNotes *ngIf="selectedTabIndex == 8" [eventId]="tabData.id"></app-cet-notes> -->

                </ng-template>
            </nz-tab>
        </nz-tabset>
    </nz-col>
</nz-row>

<app-loader *ngIf="loading"></app-loader>

<ng-template #popconfirmTpl let-popconfirm="popconfirm">
    <div class="custom-popconfirm-header">
        <span class="custom-popconfirm-title">
            Confirm Deletion
        </span>
    </div>
    <div class="custom-popconfirm-icon-area">
        <span style="display: flex; justify-content: center; margin: 18px 0 8px 0;">
            <nz-icon nzType="warning-fill" nzTheme="fill" style="font-size: 32px; color: #ff6c6c;"></nz-icon>
        </span>
    </div>
    <div class="custom-popconfirm-message description">
        Are you sure you want to delete this item?<br />
        <span style="color:#888; font-size:14px;">This action cannot be undone.</span>
    </div>
</ng-template>